import { render } from "./IndexDarkView.vue?vue&type=template&id=2152f334"
import script from "./IndexDarkView.vue?vue&type=script&lang=js"
export * from "./IndexDarkView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__